export const rugbyBundesligaSaisonstart2025 = {
  "id": "rugby-bundesliga-saisonstart-2025-26",
  "title": "Spannender Saisonstart in den Rugby-Bundesligen – Favoriten stark, Nordteams mit Ausrufezeichen",
  "slug": "rugby-bundesliga-saisonstart-2025-26",
  "publishedAt": "2025-09-18T12:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "9 min",
  "tags": ["Rugby", "Bundesliga", "Saison 2025/26", "SC Neuenheim", "Frankfurt 1880", "München RFC", "Germania List", "Hannover 78"],
  "excerpt": "Die Rugby-Bundesligen sind in die Saison 2025/26 gestartet und schon nach den ersten beiden Spieltagen zeigt sich ein abwechslungsreiches Bild: Favoriten dominieren, Nordteams überraschen und in den 2. Ligen herrscht große Spannung.",
  "img": "/images/rugby-bundesliga-saisonstart-2025-26.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Rugby-Bundesligen sind in die Saison 2025/26 gestartet und schon nach den ersten beiden Spieltagen zeigt sich ein abwechslungsreiches Bild. Während sich in der 1. Bundesliga die Favoriten SC Neuenheim, SC Frankfurt 1880 und München RFC stark präsentieren, bleiben die 2. Ligen, besonders die Nord/Ost-Staffel, extrem eng."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "1. Bundesliga: Favoriten geben den Ton an, Nordteams überraschen"
    },
    {
      "type": "paragraph",
      "content": "Der SC Neuenheim dominierte seine ersten Partien mit einem klaren 70:26-Erfolg gegen den Heidelberger RK und einem noch deutlicheren 88:7 gegen Germania List. Auch SC Frankfurt 1880 ließ keinerlei Zweifel an seiner Titelambition aufkommen und gewann souverän mit 69:3 gegen Hannover 78 sowie 52:7 gegen den Rugby Club Luxembourg. Beide Vereine führen mit jeweils 10 Punkten die Tabelle an."
    },
    {
      "type": "paragraph",
      "content": "Ebenfalls mit zwei Siegen gestartet ist der München RFC. Mit Erfolgen gegen Luxembourg (29:15) und den Berliner RC (38:31) unterstreichen die Münchener ihren Aufwärtstrend der vergangenen Jahre. Der Klub wird zunehmend als „Dark Horse“ gehandelt und könnte in dieser Saison eine entscheidende Rolle im Titelrennen spielen."
    },
    {
      "type": "paragraph",
      "content": "Besonderes Augenmerk gilt dem TSV Handschuhsheim. Der letztjährige Finalist hat bislang erst eine Partie absolviert, diese aber mit 40:27 gewonnen. Schon in der Vorsaison überzeugte der TSV durch Konstanz und Offensivkraft und will nun seine Favoritenrolle erneut bestätigen."
    },
    {
      "type": "paragraph",
      "content": "Für Aufsehen sorgten außerdem die Nordteams: Germania List bezwang die RG Heidelberg in einem packenden Duell mit 20:14 und setzte damit ein starkes Ausrufezeichen. Hannover 78 unterstrich seine Stärke mit einem klaren 41:5-Erfolg über den Heidelberger RK. Diese Ergebnisse gegen etablierte Südkonkurrenten verdeutlichen, dass die Nordvereine in dieser Saison bereit sind, im Titelrennen ein ernstes Wörtchen mitzureden."
    },
    {
      "type": "paragraph",
      "content": "Enttäuschend verläuft die Saison bisher für den Heidelberger RK, der durch Verpflichtungen bei Nationalmannschaften noch nicht mit vollem Kader antreten konnte und zwei sehr deutliche Niederlagen hinnehmen musste."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "2. Bundesliga Süd/West: Unterföhring und StuSta mit Ausrufezeichen"
    },
    {
      "type": "paragraph",
      "content": "Im Süden/Westen startete RC Unterföhring mit einer knappen 19:24-Niederlage beim RSV Köln in die Saison, meldete sich jedoch am zweiten Spieltag eindrucksvoll mit einem 68:36-Sieg in Neckarsulm zurück. Auch StuSta Rugby überzeugte mit einem deutlichen 83:21 gegen Walferdange. Der Heidelberger TV (54:15 gegen Köln) und Rugby-Club Rottweil (40:7 gegen Heusenstamm) feierten ebenfalls klare Siege. Am Tabellenende stehen Walferdange und Neckarsulm, beide noch ohne Punkte."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "2. Bundesliga Nord/Ost: Spannung pur"
    },
    {
      "type": "paragraph",
      "content": "Besonders eng geht es in der Nord/Ost-Staffel zu. Tabellenführer ist RK 03 Berlin, das nach zwei knappen, aber wichtigen Erfolgen gegen den Hamburger RC (24:23) und in Hohen Neuendorf (24:16) bei 10 Punkten steht. Victoria Linden folgt nach einem Sieg gegen Hohen Neuendorf (24:20) und einer knappen Niederlage in Berlin (15:20) auf Rang zwei."
    },
    {
      "type": "paragraph",
      "content": "Der FC St. Pauli belegt nach einem Sieg und einer Niederlage Platz drei, während RC Leipzig mit einem starken 21:7-Sieg gegen St. Pauli bereits im ersten Saisonspiel für Aufsehen sorgte. Der Hamburger RC wartet nach seiner unglücklichen 23:24-Niederlage in Berlin noch auf die ersten Punkte, hat aber ebenso wie Leipzig erst ein Spiel absolviert. Auch BSV 1892 Berlin und die SG Hohen Neuendorf sind noch mitten im Findungsprozess, haben aber bereits angedeutet, dass sie jederzeit gefährlich sein können."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Fazit: Starker Auftakt mit vielen offenen Fragen"
    },
    {
      "type": "paragraph",
      "content": "Die ersten beiden Spieltage haben eindrucksvoll gezeigt, dass die Rugby-Bundesligen 2025/26 reichlich Spannung versprechen. Während die Topfavoriten in der 1. Bundesliga ihre Stärke bestätigen und Handschuhsheim seine Titelambitionen untermauern will, setzt München seine positive Entwicklung fort und könnte zur Überraschung der Saison werden. Germania List und Hannover 78 haben mit ihren Erfolgen gegen Südkonkurrenten deutlich gemacht, dass auch die Nordstaffel ernst genommen werden muss. In den 2. Bundesligen herrscht große Ausgeglichenheit – besonders im Norden/Osten, wo die unterschiedlichen Spielzahlen die Tabelle zusätzlich verdichten und jeder Punkt entscheidend sein kann."
    },
    {
      "type": "footer",
      "content": "Artikel-Bild: © Herrmann Agenturfotografie"
    }
  ]
};
